import React from 'react'
import "../../assets/styles/spinner.css"
export default function Spinner() {
    return <div className="lds-hourglass"></div>;
}
